import { CollectionsFilter, ReportFilter, Translation } from '../../types';

type RecaPdfFilter =
  | 'differenceType'
  | 'paymentTypes'
  | 'onlyDifferences'
  | 'franchiseType'
  | 'movementType'
  | 'groupBy';

export const getAccountingInformationReportPdfFilters = (
  reportFilters: ReportFilter,
  collectionsFilters: CollectionsFilter
): ReportFilter => ({
  ...reportFilters,
  startBusinessDate: collectionsFilters.startBusinessDate,
  endBusinessDate: collectionsFilters.endBusinessDate,
  groupBy: collectionsFilters.groupBy,
});

export const getRecaPdfParameters = (
  t: Translation,
  reportFilters: ReportFilter,
  collectionsFilters: CollectionsFilter,
  includedFilters: RecaPdfFilter[],
  groupBy: string[] = collectionsFilters.groupBy
) => {
  const parameters: { title: string; value: string }[] = [];

  if (includedFilters.includes('differenceType') && reportFilters.differenceType) {
    parameters.push({
      title: t('toolbar.labels.difference-type'),
      value: t(
        `petty-cash-difference.filters.difference-type.options.${reportFilters.differenceType}`
      ),
    });
  }

  if (includedFilters.includes('paymentTypes') && reportFilters.paymentTypes.length) {
    const paymentTypes = reportFilters.paymentTypes.map(paymentType =>
      reportFilters.countryCode === 'BR' ? paymentType.tenderNameBr : paymentType.tenderId
    );
    parameters.push({ title: t('toolbar.labels.paymentType'), value: paymentTypes.join(', ') });
  }

  if (includedFilters.includes('onlyDifferences') && reportFilters.onlyDifferences) {
    parameters.push({
      title: t('operativeStructure.onlyDifferences.label'),
      value: t('operativeStructure.onlyDifferences.onlyDifferences'),
    });
  }

  if (includedFilters.includes('franchiseType') && reportFilters.franchiseType.length) {
    parameters.push({
      title: t('toolbar.labels.franchiseType'),
      value: reportFilters.franchiseType
        .map(franchiseType => t(`operativeStructure.franchiseType.${franchiseType}`))
        .join(', '),
    });
  }

  if (includedFilters.includes('movementType') && collectionsFilters.movementType.length) {
    parameters.push({
      title: t('operativeStructure.movementType.label'),
      value: collectionsFilters.movementType
        .map(movementType => t(`operativeStructure.movementType.${movementType}`))
        .join(', '),
    });
  }

  if (includedFilters.includes('groupBy')) {
    parameters.push({
      title: t('toolbar.labels.groupBy'),
      value: groupBy.map(groupByItem => t(`toolbar.groupBy.${groupByItem}`)).join(', '),
    });
  }

  return parameters;
};
